import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SimpleModalService } from 'ngx-simple-modal';
import { environment } from 'src/environments/environment';
import { Constants } from '../common/constants';
import { GUI } from '../common/gui';
import { HttpUtils } from '../common/http-utils';
import { LoaderService } from '../common/loader-service';
import { LocalStorage } from '../common/local-storage';
import { Route } from '../common/route';
import { Toast } from '../common/toast';
import { Utils } from '../common/utils';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { FileViewModalComponent } from '../file-view-modal/file-view-modal.component';
import * as CryptoJS from 'crypto-js';
import { SelectPaymentModalComponent } from '../select-payment-modal/select-payment-modal.component';
import { PaymentReceiptModalComponent } from '../payment-receipt-modal/payment-receipt-modal.component';

@Component({
  selector: 'app-application-view',
  templateUrl: './application-view.component.html',
  styleUrls: ['./application-view.component.css']
})
export class ApplicationViewComponent implements OnInit {

  private applicationViewForm: HTMLFormElement;

  private masterEncrypedApplicantId: string = this.constants.BLANK;

  private applicantId: string = this.constants.BLANK;

  private loggedUserId: string = this.constants.BLANK;

  generalDetails: any = {};

  feeDetails: any = {};

  bioDetails: any = {};

  travelDetails: any = {};

  contactDetails: any = {};

  applicationDocuments: any = {};

  isPaid: boolean = false;

  paymentDetails: any = {};

  barCodeValue: string = this.constants.BLANK;

  dependantsTotalCharges: string = this.constants.BLANK;

  isDisabledButton: boolean = false;

  hasApplicationZeroFee: boolean = false;

  isShowPaymentDetails: boolean = false;

  isPaymentDetailsFetchFromServer: boolean = false;

  applicationDocumentsArray: any = [];

  getPassportType: string = "";

  dependents: any[];

  dependentsInfo: any[];

  applicantIds: any[]


  constructor(private router: Router, private activatedRoute: ActivatedRoute, private route: Route, private httpUtils: HttpUtils, private toast: Toast, public utils: Utils, public constants: Constants,
    private loaderService: LoaderService, private simpleModalService: SimpleModalService, private localStorage: LocalStorage, private gui: GUI) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.activatedRoute.params.subscribe((params: Params) => {
      this.masterEncrypedApplicantId = params['applicantId'];
    });
    this.applicantId = this.utils.decryptString(this.masterEncrypedApplicantId);
    this.loggedUserId = this.localStorage.getLoggedUserId();
    this.getPassportType = this.localStorage.getStorageKey("tempPassportType");
    this.storeApplicationData();
  }

  ngOnInit(): void {
    this.applicationViewForm = document.forms['applicationViewForm'];
  }

  private storeApplicationData() {
    this.loaderService.startLoader();
    this.httpUtils.fetchApplicationData(this.applicantId, this.loggedUserId).then(serverResponse => {
      if (serverResponse.responseCode === this.constants.STATUS_SUCCESS) {
        this.loaderService.stopLoader();
        this.generalDetails = serverResponse.generalDetails;
        this.feeDetails = serverResponse.feeDetails;
        this.hasApplicationZeroFee = this.feeDetails.hasZeroFee;
        this.bioDetails = serverResponse.bioDetails;
        this.dependantsTotalCharges = serverResponse?.dependantsTotalCharges
        this.dependents = serverResponse.dependantsDetails;
        this.bioDetails.passportImageData = this.utils.isEmpty(this.bioDetails.passportImageData) === true ? 'assets/images/defaultImage.png' : this.bioDetails.passportImageData;
        this.isShowPaymentDetails = this.bioDetails.paymentStatus !== this.constants.STATUS_SUCCESS;
        this.travelDetails = serverResponse.travelDetails;
        this.contactDetails = serverResponse.contactDetails;
        this.processDependents(serverResponse.dependantsDetails);



        if (serverResponse.documentsDetails !== null) {
          this.applicationDocuments = serverResponse.documentsDetails;

          for (let objectKey of Object.keys(this.applicationDocuments)) {
            this.applicationDocumentsArray.push({ id: objectKey, fileBase64Data: this.applicationDocuments[objectKey][1], fileType: this.applicationDocuments[objectKey][2], label: this.applicationDocuments[objectKey][3] });
          }
        }

        let contactPostalCode = this.contactDetails.contactPostalCode;
        contactPostalCode = this.utils.isEmpty(contactPostalCode) === false ? contactPostalCode : "NA"
        this.contactDetails.contactPostalCode = contactPostalCode;
        // this.paymentDetails = serverResponse.paymentDetails;
        // this.isPaid = this.paymentDetails !== null;
        this.barCodeValue = this.constants.VISA_TYPE + '-' + this.bioDetails.applicationId;
      } else {
        this.toast.showErrorToast(serverResponse.responseMsg);
      }
    });
  }

  private processDependents(dependentsData: any[]) {
    // Initialize empty array if no dependents
    this.dependents = dependentsData || [];

    // Transform data if needed (example: format dates)
    this.dependents = this.dependents.map(dependent => ({
      ...dependent,
      // Add formatted date properties if needed
      formattedBirthDate: this.formatDate(dependent.dateOfBirth),
      // Ensure all required fields exist
      ageError: false
    }));

  }

  private formatDate(dateString: string): string {
    if (!dateString) return '';
    try {
      const [day, month, year] = dateString.split('/');
      return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
    } catch (e) {
      console.warn('Error formatting date:', dateString);
      return dateString;
    }
  }


  backToPage(): void {
    this.gui.openDashboardPage();
  }

  editApplication(): void {
    this.gui.openApplicationAddEditPage(this.applicantId);
  }

  openConfirmation(shallPayNow: number): void {
    const message = "<span class='app-confirm'>Please check to ensure that your completed application is accurate before you submit the application and an application ID is generated.An application cannot be edited once an application ID has been generated.</span>";
    const modalParamsObject = { title: "Confirmation", message: message, confirmButtonLabel: "Submit Application", cancelButtonLabel: "Cancel", isShowCancelButton: true };
    this.simpleModalService.addModal(ConfirmationModalComponent, modalParamsObject, { autoFocus: true }).subscribe((isConfirmed: boolean) => {
      if (isConfirmed === true) {
        this.confirmApplication(shallPayNow);
      }
    });
  }

  // private async confirmApplication(shallPayNow: number) {
  //   this.isDisabledButton = true;
  //   this.loaderService.startLoader();

  //   try {
  //     // Confirm main applicant
  //     const mainResponse = await this.httpUtils.confirmApplication(this.loggedUserId, this.applicantId, this.bioDetails?.applicationId);

  //     if (mainResponse.responseCode !== this.constants.STATUS_SUCCESS) {
  //       this.toast.showErrorToast(mainResponse.responseMsg);
  //       return;
  //     }

  //     // Confirm dependents if any
  //     if (this.dependents?.length) {
  //       try {
  //         for (const dependent of this.dependents) {
  //           const depResponse = await this.httpUtils.confirmApplication(
  //             this.loggedUserId,
  //             dependent.applicantId,
  //             dependent.applicationId
  //           );

  //           if (depResponse?.responseCode !== this.constants.STATUS_SUCCESS) {
  //             this.toast.showErrorToast(`Confirmation failed for dependent (ID: ${dependent.applicantId})`);
  //             return;
  //           }
  //         }
  //       } catch (error) {
  //         this.toast.showErrorToast('Error confirming dependents');
  //         console.error('Error confirming dependents:', error);
  //         return;
  //       }
  //     }

  //     // All confirmations succeeded
  //     if (shallPayNow === this.constants.TRUE) {
  //       this.gui.openSelectPaymentPage(this.applicantId)
  //       // this.startPayment();
  //     } else {
  //       this.gui.openDashboardPage();
  //     }

  //   } catch (error) {
  //     this.toast.showErrorToast("An unexpected error occurred while confirming the application.");
  //   } finally {
  //     this.loaderService.stopLoader();
  //     this.isDisabledButton = false;
  //   }
  // }






  // private startPayment(): void {
  //   const data = `${environment.raveMerchant}${this.feeDetails?.totalCharges}${this.bioDetails?.applicationId
  //     }`;
  //   const hash = CryptoJS.HmacSHA1(data, environment.raveKey).toString();
  //   const payload = {
  //     serviceId: environment.raveService,
  //     txnRefNumber: this.bioDetails?.applicationId,
  //     amount: this.feeDetails?.totalCharges,
  //     countryId: this.generalDetails?.nationality,
  //     hash: hash,
  //     miscData: `${this.bioDetails?.referenceId} | ${this.bioDetails?.applicationId} | ${this.bioDetails?.fullName}`,
  //     successUrl: `${environment.keycloakRedirectUrl}rave-payment/${this.bioDetails?.applicationId}/${this.bioDetails?.referenceId}`,
  //     cancelUrl: `${environment.keycloakRedirectUrl}rave-payment-fail/${this.bioDetails?.applicationId}/${this.bioDetails?.referenceId}`,
  //   };
  //   try {
  //     this.httpUtils
  //       .startRavePayment(payload)
  //       .then((serverResponse) => {
  //         console.log("payment serveer response", serverResponse)
  //         if (serverResponse?.data?.redirect_url) {
  //           window.location.href = serverResponse?.data?.redirect_url;
  //         }
  //       })
  //       .catch((error) => {
  //         console.error('Error while starting payment:', error);
  //       });
  //   } catch (error) {
  //     console.error('Unexpected error:', error);
  //   }
  // }


  openGatewayModal() {
    const applicationsList = this.applicantIds
    this.simpleModalService.addModal(SelectPaymentModalComponent, {
      applicationsList: applicationsList
    }).subscribe(result => {
      if (result) {
        console.log('Selected result:', result);
      }
    });
  }

  private confirmApplication(shallPayNow: number) {
    this.isDisabledButton = true;
    this.loaderService.startLoader();
    const appIDS = this.applicantIds || [];


    const mainId = [
      this.applicantId,

    ]
    if (this.dependents && this.dependents.length > 0) {
      const newIds = [
        this.applicantId,
        ...this.dependents.map(d => d.applicantId)
      ].filter(id => !appIDS.includes(id));

      appIDS.push(...newIds);
    }

    this.applicantIds = this.dependents.length > 0 ? appIDS : mainId;

    this.httpUtils.confirmApplicationV2(this.loggedUserId, this.applicantId, this.applicantIds).then(serverResponse => {
      if (serverResponse.responseCode === this.constants.STATUS_SUCCESS) {
        if (shallPayNow === this.constants.TRUE) {
          // this.gui.openSelectPaymentPage(this.applicantId)
          this.openGatewayModal()
          this.loaderService.stopLoader();
        } else {
          this.loaderService.stopLoader();
          this.gui.openDashboardPage();
        }
      } else {
        this.loaderService.stopLoader();
        this.isDisabledButton = false;
        this.toast.showErrorToast(serverResponse.responseMsg);
      }
    });
  }



  private startPayment(): void {


    const amount = this.feeDetails?.totalCharges.toFixed(2);
    const transactionId = this.bioDetails?.applicationId?.toString();
    const referenceId = this.bioDetails?.referenceId;

    const mainUserInfo = {
      appId: this.bioDetails.applicationId,
      refNumber: this.bioDetails.referenceId
    };

    const payload = {
      loggedUserId: this.loggedUserId,
      txnRefNumber: transactionId,
      amount,
      countryId: "US",
      successUrl: `${environment.keycloakRedirectUrl}/dashboard`,
      cancelUrl: `${environment.keycloakRedirectUrl}/dashboard`,
      miscData: {
        applications: [
          mainUserInfo,
          ...this.dependents.map(dep => ({
            appId: dep.applicationId,
            refNumber: dep.referenceId
          }))
        ]
      }
    };

    // Start payment directly
    this.httpUtils.startRavePayment(payload)
      .then((paymentResponse) => {
        const redirectUrl = paymentResponse?.data?.redirect_url;
        if (redirectUrl) {
          this.toast.showSuccessToast('Redirecting to payment gateway...');
          window.location.href = redirectUrl;
        } else {
          // throw new Error('No redirect URL returned from payment server.');
          this.toast.showErrorToast(paymentResponse?.responseMsg || 'An error occurred while processing the payment.');
        }
      })
      .catch((error) => {
        console.error('Payment process failed:', error);
        this.toast.showErrorToast(error?.message || 'An error occurred while processing the payment.');
      });
  }




  private initiatePayment() {

    const dependantIds = this.dependents.map(dep => dep.applicantId);
    const applicationsList = Array.from(new Set([this.applicantId, ...dependantIds]));

    this.httpUtils.initiatePayment(this.loggedUserId, applicationsList).then(serverResponse => {
      if (serverResponse.responseCode === this.constants.STATUS_SUCCESS) {
        this.openIOSPaymentPage(serverResponse.redirectUrl);
      } else {
        this.loaderService.stopLoader();
        this.toast.showErrorToast(serverResponse.responseMsg);
      }
    });
  }


  private openIOSPaymentPage(redirectUrl: string) {
    if (environment.isEnableIOSV2 === true) {
      this.loaderService.startLoader();
      window.location.href = redirectUrl;
    } else {
      this.applicationViewForm.action = environment.serverBaseUrl + 'payment/openIOSPaymentPage';
      this.applicationViewForm.loggedUserId.value = this.loggedUserId;
      this.applicationViewForm.submit();
    }
  }

  printApplication(): void {
    window.print();
  }

  printReceipt(): void {
    this.simpleModalService.addModal(PaymentReceiptModalComponent, {
      applicantId: this.applicantId,
      isV1Application: this.constants.FALSE
    }, {
      closeOnClickOutside: false
    });
  }

  storeFeeAndPaymentDataFromIOS(): void {
    this.isShowPaymentDetails = !this.isShowPaymentDetails;

    if (this.isPaymentDetailsFetchFromServer === true) {
      return;
    }

    this.loaderService.startLoader();
    const applicationIdV1 = this.bioDetails.applicationId;
    const referenceIdV1 = this.bioDetails.referenceId;
    this.httpUtils.fetchFeeAndPaymentDataFromIOS(applicationIdV1, referenceIdV1).then(serverResponse => {
      this.loaderService.stopLoader();
      if (serverResponse.responseCode === this.constants.STATUS_SUCCESS) {
        this.feeDetails = serverResponse.feeDetails;
        this.paymentDetails = serverResponse.paymentDetails;
        this.isPaid = this.paymentDetails !== null;
        this.isPaymentDetailsFetchFromServer = true;
      } else {
        this.toast.showErrorToastWithCallbackFunction(serverResponse.responseMsg, this.openDashboard.bind(null, this.gui));
      }
    });
  }

  private openDashboard(gui: GUI): void {
    gui.openDashboardPage();
  }

  openFileViewModal(fileBase64Data: string, fileType: string) {
    this.simpleModalService.addModal(FileViewModalComponent, { fileBase64Data: fileBase64Data, fileType: fileType }, { autoFocus: true }).subscribe((imageBase64Data: string) => {

    });
  }
  // dependentsArray = this.dependents.map(item => item.body.bioDetails);


}
